<template>
  <v-app>
    <v-container fluid class="px-0 mx-0">
      <v-alert v-if="success" colored-border border="top" color="success"
        >Enregistrement réussi, veuillez confirmer votre adresse email en
        cliquant sur le lien de confirmation à l'interieur</v-alert
      >
      <v-snackbar top block v-model="error" color="error"
        >Une erreur s'est produite</v-snackbar
      >

      <template v-if="!register">
        <v-col class="pb-0">
          <v-autocomplete
            v-model="model"
            prepend-icon="mdi-magnify"
            :items="items"
            dense
            rounded
            :loading="isLoading"
            filled
            :search-input.sync="search"
            hide-no-data
            hide-selected
            item-text="search_nom"
            placeholder="Ville ou code postal"
            return-object
            no-filter
          ></v-autocomplete>
        </v-col>
        <v-col cols="12">
          <LMap
            ref="map"
            @click="changeMarkerPoint"
            :center="[47, 2]"
            :zoom="6"
            style="height: 200px"
          >
            <LTileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <LMarker
              v-if="model.lat && model.lon"
              :lat-lng="[model.lat, model.lon]"
            />
          </LMap>
        </v-col>
        <v-col class="my-0 pb-0">
          <v-text-field
            v-model="model.nom"
            filled
            dense
            rounded
            placeholder="Webcam de Bordeaux ..."
            label="Nom de votre webcam"
          />
        </v-col>
        <v-col class="my-0 py-0">
          <v-text-field
            v-model="url_webcam"
            filled
            dense
            rounded
            placeholder="https://exemple.com/capture.jpg"
            label="URL de votre webcam"
          />
        </v-col>
        <v-col class="my-0 py-0">
          <v-text-field
            v-model="url_website"
            filled
            dense
            rounded
            placeholder="https://exemple.com"
            label="URL de votre site internet"
          />
        </v-col>
        <v-col>
          <v-btn
            @click="register = true"
            :disabled="
              !model.lat || !model.lon || !model.nom || !url_webcam
                ? true
                : false
            "
            rounded
            color="primary"
            block
            >Ajouter</v-btn
          >
        </v-col>
      </template>

      <v-col cols="12" md="8" class="px-0 mx-0" v-else>
        <v-col cols="12">
          <v-btn icon @click="register = false"
            ><v-icon>mdi-arrow-left</v-icon></v-btn
          >
          <h2>S'enregistrer</h2>
          <template>
            <v-form
              ref="registerFormRef"
              @submit.prevent="registersubmit"
              lazy-validation
            >
              <v-text-field
                filled
                rounded
                id="register-last-name"
                label="Nom"
                type="text"
                name="nom"
                v-model="user.user_nom"
                :rules="[(v) => !!v || 'Une erreur est survenue']"
                required
              />
              <v-text-field
                filled
                rounded
                dense
                label="Prénom"
                type="text"
                name="firstnameRegister"
                v-model="user.user_prenom"
                :rules="[(v) => !!v || 'Une erreur est survenue']"
                required
              />
              <v-text-field
                filled
                rounded
                dense
                label="Email"
                v-model="user.user_email"
                type="email"
                name="emailRegister"
                :rules="[
                  (v) => !!v || 'Une erreur est survenue',
                  (v) => /.+@.+\..+/.test(v) || 'Une erreur est survenue',
                ]"
                required
              />
              <v-text-field
                filled
                rounded
                dense
                label="Mot de passe"
                type="password"
                name="passwordRegister"
                v-model="user.user_password"
                :rules="[(v) => !!v || 'Une erreur est survenue']"
                required
              />
              <v-text-field
                filled
                rounded
                dense
                label="Confirmation mot de passe"
                type="password"
                name="confirmPasswordRegister"
                v-model="user.passordConfirm"
                :rules="[
                  (v) => v === user.user_password || 'Une erreur est survenue',
                ]"
                required
              />
              <v-btn
                elevation="0"
                block
                rounded
                dense
                color="primary"
                type="submit"
                :loading="registerLoading"
                >S'enregistrer</v-btn
              >
              <hr class="my-6" />
            </v-form>
          </template>
        </v-col>
      </v-col>
    </v-container>
  </v-app>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import axios from "axios";
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  computed: {
    items() {
      return this.entries.map((chunk) =>
        chunk.cp
          ? {
              ...chunk,
              search_nom: `${chunk.nom} (${chunk.cp.slice(0, 2)}) ${chunk.iso}`,
            }
          : { ...chunk, search_nom: `${chunk.nom} ${chunk.iso}` }
      );
    },
  },
  data: () => ({
    drawer: null,
    news: false,
    descriptionLimit: 60,
    url_webcam: null,
    url_website: null,
    isLoading: false,
    entries: [],
    id_user_create: false,
    register: false,
    model: {
      lat: null,
      lon: null,
      nom: null,
    },
    search: null,

    // Register
    user: {
      user_nom: null,
      user_prenom: null,
      user_email: null,
      user_password: null,
    },
    phoneValid: null,
    // Form settings
    loginForm: true,
    // Error snackbar
    success: false,
    error: false,
    loading: false,
    loginLoading: false,
    registerLoading: false,
  }),
  methods: {
    async registersubmit() {
      this.registerLoading = true;
      if (this.$refs.registerFormRef.validate()) {
        try {
          let user = await axios.post(
            `https://auth.previmeteo.net/users`,
            this.user
          );
          this.id_user_create = user.data.insertId;
          this.submitwebcam();
          this.success = true;
        } catch (err) {
          console.error(err);
          this.error = true;
        }
      }
      this.registerLoading = false;
    },
    changeMarkerPoint(e) {
      if (!this.model) this.model = { lat: null, lon: null };
      this.model.lat = e.latlng.lat;
      this.model.lon = e.latlng.lng;
    },
    submitwebcam() {
      axios.post("https://api-my.previmeteo.net/webcams", {
        name: this.model.nom,
        id_user: this.id_user_create,
        url_webcam: this.url_webcam,
        longitude: this.model.lon,
        latitude: this.model.lat,
        url_website: this.url_website,
      });
    },
  },
  async mounted() {
    if (this.$route.query.geoname) {
      let { data } = await axios.get(
        `https://api-my.previmeteo.net/city/${this.$route.query.geoname}`
      );
      this.model = {
        lat: data.lat,
        lon: data.lon,
        nom: data.name,
      };
    }
  },
  watch: {
    model() {
      this.$refs.map.mapObject.panTo([this.model.lat, this.model.lon]);
    },
    search(val) {
      this.isLoading = true;

      // Lazily load input items
      axios
        .get(`https://api-my.previmeteo.net/cities?search=${val}`)
        .then((res) => {
          this.entries = res.data;
          this.count = res.data.length;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<style>
.leaflet-container {
  z-index: 1;
}
.col {
    margin: 0px!important;
    padding-right: 0px!important;
    padding-left: 0px!important;
}
</style>